import $ from 'jquery'
import Vue from 'vue'
import store from 'store'
import { mapState, mapActions } from 'vuex'

/**
 * Header
 */

export default el => new Vue({
  el,
  store,
  data () {
    return {
      menuActive: false
    }
  },
  mounted () {
    console.log('[Vue] Header mounted successfully');
    $('.js-header .js-mi-cover .js-mi-open').click(function (e) {
      e.preventDefault()

      const $header = $(this).closest('.js-header')
      $header.addClass('menu-opened')
      $header.find('.js-mi-cover').removeClass('active')

      const $cover = $(this).closest('.js-mi-cover')
      $cover.addClass('active')
      const featuredImage = $(this).data('image')

      if (featuredImage) {
        $('.mi-desktop-nav .image_container').html(`<img src="${featuredImage}"/>`)
      } else {
        $('.mi-desktop-nav .image_container').html('')
      }
    })

    $('.js-header .js-mi-cover .js-mi-close').click(function (e) {
      e.preventDefault()

      const $header = $(this).closest('.js-header')
      $header.removeClass('menu-opened')

      const $cover = $(this).closest('.js-mi-cover')
      $cover.removeClass('active')
    })
  },
  methods: {
    ...mapActions('cart', [
      'toggleCart',
      'closeCart'
    ]),
    ...mapActions('global', [
      'toggleSearch'
    ]),
    toggleMenu () {
      console.log('[Vue] toggleMenu clicked. Current state:', this.menuActive);
      this.menuActive = !this.menuActive

      if (this.menuActive) {
        $('.header').addClass('mobile-menu-opened')
        $('#nav-mobile').addClass('is-visible')
        $('html, body').addClass('no-scroll')
        const submenu = document.querySelector('ul.active-sub-menu')
        if (submenu) {
          document.body.classList.add('active-sub-menu-t')
        }
      } else {
        $('.header').removeClass('mobile-menu-opened')
        $('#nav-mobile').removeClass('is-visible')
        $('html, body').removeClass('no-scroll')
        $('body').removeClass('active-sub-menu-t')
      }
    }
  }
})
